import SVG from "svg.js";

import Part from "@/components/body/parts/part";
import { BodyConfig } from ".";
import { Store } from "vuex";
import { Patient } from "@/store/modules/patient/types";

export default class Uterus extends Part {
  initialized = false;
  placentaPost: SVG.Element;
  postPartum: SVG.Element;
  prenatal: SVG.Element;
  caseStates: any;
  baby2: SVG.Element;

  getExtraData(patient: Patient) {
    this.extraData = {
      caseStateName: patient.census.caseStateName,
      caseState: this.caseStates[patient.census.caseState],
      multiple: patient.body.atoms.multiple
    };
  }

  constructor(config: BodyConfig, container: SVG.Container, store: Store<any>) {
    super(config, container, store);
    this.svgGroup.move(135, 360);

    this.placentaPost = SVG.select(
      "#placentaPost",
      this.container.node
    ).first();
    this.postPartum = SVG.select("#postPartum", this.container.node).first();

    this.prenatal = SVG.select("#prenatal", this.container.node).first();
    this.baby2 = SVG.select("#baby2", this.container.node).first();
    const vars = this.store.getters["patient/vars"];
    if (vars) {
      this.caseStates = vars.caseStates;
    } else {
      this.caseStates = {};
    }

    // Hide them all until update date determines which should be shown
    this.hideAll();
  }

  private hideAll() {
    this.placentaPost.hide();
    this.postPartum.hide();
    this.prenatal.hide();
    this.baby2.hide();
  }

  updateData(patient: Patient | null) {
    super.updateData(patient);

    if (!patient || !this.atom) {
      return;
    }

    this.hideAll();

    //---------------------------------------------------------
    // if g == p, then the baby is out
    //---------------------------------------------------------
    const s = this.atom.legend.split("/");
    const babyOut = s.length == 2 && s[0] == s[1] ? true : false;
    const caseStateGreaterThanFive =
      this.extraData.caseState && this.extraData.caseState.stage >= 5;

    if (this.extraData.caseStateName === "Delivered") {
      this.placentaPost.show();
    } else if (caseStateGreaterThanFive || babyOut) {
      this.postPartum.show();
    } else {
      this.prenatal.show();
      if (this.extraData.multiple.value > 0) {
        this.baby2.show();
      }
    }
  }
}
